/* eslint-disable indent */
import {Col, Row} from 'react-bootstrap';
import {language} from '../../language';
import '../../styles/user/main.scss';
import '../../styles/user/order-history.scss';
import {apiGet} from '../../apis';
import {trackPromise} from 'react-promise-tracker';
import {useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {orderStatusMappings} from '../../types/order';
import sls from 'react-secure-storage';
import {useMsal} from '@azure/msal-react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import Lottie from 'lottie-react';
import dataNotFound from '../../assets/images/not-found-item.json';
import {formatDateTime} from '../../helpers/datetime';
import OrderHistoryDetail from './OrderHistoryDetail';
import 'react-quill/dist/quill.snow.css';

const TempClose = () => {
  const {instance, accounts} = useMsal();
  const [currentOrder, setCurrentOrder] = useState();
  const [showHistories, setShowHistories] = useState(true);
  const slsHrMobileData = sls.getItem('slsHrMobileData');
  const hrMobileLanguage = useSelector(
    (state) => state.app.slsHrMobileLanguage,
  );
  const navigate = useNavigate();
  const [orderHistories, setOrderHistories] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [messageTh, setMessageTh] = useState('');
  const [messageEn, setMessageEn] = useState('');
  const [messageLang, setMessageLang] = useState('en');
  const [bannerImage, setBannerImage] = useState('');
  const [bannerLoading, setBannerLoading] = useState(false);
  const [bannerError, setBannerError] = useState(false);

  // Helper function to ensure Base64 has proper prefix
  const ensureBase64Prefix = (base64String) => {
    if (!base64String) return '';

    // If already has data URI prefix, return as is
    if (base64String.startsWith('data:image/')) {
      return base64String;
    }

    // Detect image type from Base64 signature
    let mimeType = 'image/jpeg'; // default
    if (base64String.startsWith('iVBORw0KGgo')) {
      mimeType = 'image/png';
    } else if (base64String.startsWith('R0lGODlh')) {
      mimeType = 'image/gif';
    } else if (base64String.startsWith('/9j/')) {
      mimeType = 'image/jpeg';
    }

    return `data:${mimeType};base64,${base64String}`;
  };

  console.log('TempClose - Banner Image:', bannerImage ? 'Has image' : 'No image', bannerImage?.substring(0, 50));

  // Fetch EmpClose messages
  useEffect(() => {
    (async () => {
      try {
        const res = await apiGet({
          uri: `Maintainance/EmpCloseStatus`,
          msal: {instance, accounts},
        });
        console.log('TempClose - API Response:', {
          messageTh: res?.messageTh ? 'exists' : 'empty',
          messageEn: res?.messageEn ? 'exists' : 'empty',
          bannerImage: res?.bannerImage ? 'exists' : 'empty',
          bannerImagePreview: res?.bannerImage?.substring(0, 50),
        });
        setMessageTh(res?.messageTh || '');
        setMessageEn(res?.messageEn || '');
        const formattedBanner = ensureBase64Prefix(res?.bannerImage || '');
        console.log('TempClose - Formatted Banner:', formattedBanner?.substring(0, 80));
        setBannerImage(formattedBanner);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [instance, accounts]);

  useEffect(() => {
    if (!orderHistories?.length || !searchParams.get('orderNumber')) return;

    const order = orderHistories?.find(
      (v) => v?.orderNumber == searchParams.get('orderNumber'),
    );

    if (order) {
        setCurrentOrder(order);
        setShowHistories(false);
    }
  }, [searchParams, orderHistories]);

  useEffect(() => {
    if (!slsHrMobileData?.authUser?.employeeId) return;

    trackPromise(
      (async () => {
        try {
          const getHistories = await apiGet({
            uri: `Order/history?employeeId=${slsHrMobileData?.authUser?.employeeId || ''}`,
            msal: {
              instance: instance,
              accounts: accounts,
            },
          });

          setOrderHistories(getHistories);
        } catch (error) {
          console.error(error);
        }
      })(),
    );
  }, [instance, accounts, slsHrMobileData?.authUser?.employeeId]);

  const handleOpenDetail = (v) => {
    setSearchParams({orderNumber: v?.orderNumber});
    setCurrentOrder(v);
    setShowHistories(false);
  };

  const handleCloseDetail = (val) => {
    setShowHistories(val);
    if (val) {
        setSearchParams({});
        setCurrentOrder(null);
    }
  };

  const preferredMessage = messageLang === 'th' ? messageTh : messageEn;
  const fallbackMessage = messageLang === 'th' ? messageEn : messageTh;
  const displayMessage = preferredMessage && preferredMessage !== '<p><br></p>' ?
    preferredMessage :
    ((fallbackMessage && fallbackMessage !== '<p><br></p>') ? fallbackMessage : '');

  if (!showHistories && currentOrder) {
    return (
        <OrderHistoryDetail
            orderHistory={currentOrder}
            setShowHistories={handleCloseDetail}
        />
    );
  }

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '3rem'}}>
      <div className="container py-4">

        <Row className="gy-4">

        {/* Message Card */}
        <Col xs={12} lg={12}>
            <div
            className="bg-white rounded-4 shadow-sm h-100 d-flex flex-column"
            style={{overflow: 'hidden', minHeight: '400px', position: 'relative'}}
            >
            <div className="p-4 my-auto">
                <div className="position-absolute top-0 end-0 p-3 d-flex gap-2">
                  <button
                    type="button"
                    className={`btn btn-sm ${messageLang === 'en' ? 'btn-dark' : 'btn-outline-secondary'}`}
                    onClick={() => setMessageLang('en')}
                  >
                    EN
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${messageLang === 'th' ? 'btn-dark' : 'btn-outline-secondary'}`}
                    onClick={() => setMessageLang('th')}
                  >
                    TH
                  </button>
                </div>

                <div className="text-center">
                  <img
                  className="w-100 mb-4"
                  style={{maxWidth: '160px'}}
                  src="/images/icon-h.png"
                  alt="Pandora Logo"
                  />
                </div>

                {/* Content Container */}
                <div className="px-md-4 ql-editor" style={{padding: 0}}>
                {displayMessage && (
                    <div
                        style={{
                            lineHeight: '1.6',
                            fontSize: '1rem',
                            color: '#333',
                            fontFamily: '"Montserrat-Regular", "SukhumvitSet-Medium"',
                        }}
                        dangerouslySetInnerHTML={{__html: displayMessage}}
                    />
                )}
                </div>
            </div>
            </div>
        </Col>

        {/* EPP Banner */}
        <Col xs={12} lg={12}>
            <div
            className="text-center h-100 d-flex align-items-center justify-content-center bg-white rounded-4 shadow-sm p-3"
            style={{minHeight: '400px', position: 'relative'}}
            >
            {bannerLoading && (
              <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            {bannerImage && !bannerError ? (
              <img
                  className="w-100"
                  style={{
                    borderRadius: '8px',
                    objectFit: 'contain',
                    maxHeight: '75vh',
                    maxWidth: '100%',
                    height: 'auto',
                    display: bannerLoading ? 'none' : 'block',
                  }}
                  src={bannerImage}
                  alt="EPP Banner"
                  onError={(e) => {
                    console.error('TempClose - Image failed to load, using fallback');
                    console.error('TempClose - Image src length:', bannerImage?.length);
                    setBannerError(true);
                    setBannerLoading(false);
                  }}
                  onLoad={() => {
                    console.log('TempClose - Image loaded successfully');
                    console.log('TempClose - Image size:', bannerImage?.length, 'characters');
                    setBannerLoading(false);
                    setBannerError(false);
                  }}
                  onLoadStart={() => {
                    console.log('TempClose - Image loading started...');
                    setBannerLoading(true);
                  }}
              />
            ) : (
              <img
                  className="w-100"
                  style={{
                    borderRadius: '8px',
                    objectFit: 'contain',
                    maxHeight: '75vh',
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                  src="/images/epp_baner.png"
                  alt="EPP Banner Default"
              />
            )}
            </div>
        </Col>

        {/* Order History Section */}
        {orderHistories?.length > 0 && (
        <Col xs={12}>
            <div
            className="bg-white rounded-4 shadow-sm h-100 d-flex flex-column"
            style={{maxHeight: '85vh'}}
            >
            <div className="p-3 border-bottom text-center flex-shrink-0">
                <h5 className="mb-0 fw-bold text-secondary">
                {language?.OrderStatus?.[hrMobileLanguage]}
                </h5>
            </div>

            <div className="p-3 flex-grow-1" style={{overflowY: 'auto'}}>
                <div className="list-group list-group-flush">
                    {orderHistories?.map((v, i) => (
                    <div
                        key={i}
                        className="list-group-item list-group-item-action border rounded-3 mb-2 p-3 shadow-sm"
                        style={{cursor: 'pointer'}}
                        onClick={() => handleOpenDetail(v)}
                    >
                        <Row className="align-items-center text-center">
                        <Col xs={4} className="text-start">
                            <div className="text-muted small">Date</div>
                            <div className="fw-bold">
                            {formatDateTime({
                                dateTime: v?.createdAt,
                                dateOnly: true,
                                convertToThai: hrMobileLanguage == 'th',
                            })}
                            </div>
                        </Col>

                        <Col xs={4}>
                            <div
                                className="badge rounded-pill px-3 py-2"
                                style={{
                                backgroundColor: `${orderStatusMappings?.find((osm) => osm?.key == v?.orderStatus?.orderStatusId)?.color}20`,
                                color: orderStatusMappings?.find((osm) => osm?.key == v?.orderStatus?.orderStatusId)?.color,
                                fontSize: '0.85rem',
                                }}
                            >
                            {orderStatusMappings?.find((osm) => osm?.key == v?.orderStatus?.orderStatusId)?.displayLabel?.[hrMobileLanguage]}
                            </div>
                        </Col>

                        <Col xs={4} className="text-end">
                            <div className="text-muted small">Total</div>
                            <div className="fw-bold text-dark">
                            {v?.total?.toLocaleString('en-US') || 0} ฿
                            </div>
                        </Col>
                        </Row>
                    </div>
                    ))}
                </div>
            </div>
            </div>
        </Col>
        )}

        </Row>
      </div>
    </div>
  );
};

export default TempClose;
